import { render, staticRenderFns } from "./EducationCategories.vue?vue&type=template&id=0c6c1c16"
import script from "./EducationCategories.vue?vue&type=script&lang=js"
export * from "./EducationCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports